import React from 'react';
import './App.css';
import ImageCarousel from './components/ImageCarousel';
import logo from './logo faso intell.png'; // Importez votre logo

function App() {
  return (
    <div className="App">
      <div className="header">
        <img src={logo} alt="FASO INTELL Logo" className="logo" />
        <h1>Faso Intell - Intelligence Civile et Commerciale - Burkina Faso</h1>
      </div>
      <ImageCarousel />
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>FASO INTELL</h3>
            <p>Intelligence Civile et Commerciale</p>
            <p>Burkina Faso</p>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p>Email: contact@fermatinga.com</p>
            <p>Tél: +226 54 50 87 67</p>
          </div>
          <div className="footer-section">
            <h3>Suivez-nous</h3>
            <div className="social-links">
              <a href="#">Facebook</a>
              <a href="#">LinkedIn</a>
              <a href="#">Twitter</a>
              <a href="#">WhatsApp</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 FASO INTELL - Intelligence Civile et Commerciale. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;